


































































import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { detailedDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { AttachmentRequest, IAttachmentRequest } from "@/models/attachment-request.entity";
import { IReport } from "@/models/report.entity";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";
import { requiredRule } from "@/lib/rules/requiredRule";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import ReportActivityBoxShareComponentScreenOrder from "./ReportActivityBoxShareComponentScreenOrder.vue";
import CustomFieldBoolean from "../report/CustomFieldBoolean.vue";
import { ISharedContent } from "@/models/shared-content.entity";

@Component({
  components: {
    ConfirmActionDialog,
    CustomFieldBoolean,
    ReportActivityBoxShareComponentScreenOrder
  },
  filters: { detailedDate }
})
export default class ReportRequestInformationDialog extends Vue implements IDialog {
  @Prop()
  report!: IReport;

  @Prop()
  screens?: ReportScreenEnum[];

  @Prop()
  name?: string;

  @Prop()
  sharedContent?: ISharedContent;

  isDialogActive = false;
  isRequestImageLoading = false;
  request: IAttachmentRequest | null = null;
  newScreen: ReportScreenEnum | null = null;
  isExpiringLink = true;
  sharedName =
    this.name ??
    `${this.$t("objects.attachmentRequest.title").toString()} ${this.report.claimNumber} ${this.report.title}`;

  readonly defaultValidBy = new Date(Date.now() + 12096e5).toISOString().substring(0, 10);

  validBy = this.defaultValidBy;

  open() {
    this.request = new AttachmentRequest({
      partnerId: this.report.partnerId,
      refs: [
        {
          refType: BackendResourceEnum.REPORT,
          refId: this.report._id
        }
      ]
    });
    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  addNewScreen() {
    if (!this.newScreen) return;

    this.screenSelection.push(this.newScreen);
    this.newScreen = null;
  }

  removeNonSelectableScreens(screens: ReportScreenEnum[]) {
    return screens.filter(screen => !AttachmentRequest.INVALID_SCREENS.includes(screen));
  }

  screenSelection = [...this.selectableScreens];

  get selectableScreens() {
    if (this.screens && this.screens.length) {
      return this.screens;
    }

    return this.removeNonSelectableScreens(
      (PartnerModule.partner.settings?.reportSettings.screenOrder ?? []) as ReportScreenEnum[]
    );
  }

  get unselectedSelectableScreens() {
    return this.selectableScreens.filter(screen => !this.screenSelection.includes(screen));
  }

  get requiredRule() {
    return [requiredRule()];
  }

  async requestImages() {
    this.isRequestImageLoading = true;

    try {
      if (!this.request) {
        this.request = new AttachmentRequest({
          partnerId: this.report.partnerId,
          reportId: this.report.id,
          refs: [
            {
              refType: BackendResourceEnum.REPORT,
              refId: this.report._id
            }
          ]
        });
      }

      this.request.title = this.sharedName;
      this.request.screenOrder = this.screenSelection;
      this.request.validBy = this.isExpiringLink ? new Date(this.validBy).toISOString() : undefined;

      const created = await this.request.create();

      if (this.sharedContent) {
        console.log(this.sharedContent);
        await this.sharedContent.addRef({
          refType: BackendResourceEnum.ATTACHMENT_REQUEST,
          refId: created.id
        });

        this.$toast.success(this.$t("objects.attachmentRequest.addedToSharedContent"));
      }

      created.copyLinkToClipboard();
      this.close();
    } catch (error) {
      handleError(error);
    } finally {
      this.isRequestImageLoading = false;
    }
  }
}
